module.exports = "<p>\r\n  games works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/games/games.component.html
// module id = ./src/app/games/games.component.html
// module chunks = main